import React from 'react'
import AlertComponent from '../components/AlertComponent'
import { useDispatch, useSelector } from 'react-redux';
import { deleteUserDetail } from '../redux/action/userDetailAction';
import { openFormDelete } from '../redux/slice/userDetailSlice';

const FormDeleteuser = ({ param }) => {
    const { idUserDetail, isOpenForm, state } = useSelector( (state) => state.userDetail);
    const dispatch = useDispatch();

    const handleFormSubmit = async (values) => {
        // console.log(values)
        if (state === "delete") {
            param.id = idUserDetail;
            dispatch(deleteUserDetail(param))
        }
      };

  return (
    <AlertComponent
        show={isOpenForm}
        close={() => dispatch(openFormDelete({ open: false, state: "close" }))}
        action={() => handleFormSubmit()}
      />
  )
}

export default FormDeleteuser